'use client';

export const MIN_CONVERSATION_TWEETS_FOR_SUMMARY = 6;
export const MAX_TWEETS_FOR_CHAT_CONTEXT = 40;
